/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuicklySignHealthCheckResponse
 */
export interface QuicklySignHealthCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QuicklySignHealthCheckResponse
     */
    success: boolean;
}

/**
 * Check if a given object implements the QuicklySignHealthCheckResponse interface.
 */
export function instanceOfQuicklySignHealthCheckResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;

    return isInstance;
}

export function QuicklySignHealthCheckResponseFromJSON(json: any): QuicklySignHealthCheckResponse {
    return QuicklySignHealthCheckResponseFromJSONTyped(json, false);
}

export function QuicklySignHealthCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuicklySignHealthCheckResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['Success'],
    };
}

export function QuicklySignHealthCheckResponseToJSON(value?: QuicklySignHealthCheckResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Success': value.success,
    };
}

